// extracted by mini-css-extract-plugin
export default {"adminLoginPage":"styles_adminLoginPage__S39M5","formLogin":"styles_formLogin__9t+vp"};